import { ScatterChart } from '@mantine/charts';

import { getSeriesColor } from '#core/lib/formatters/colors.ts';
import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import type { ChartRendererProps } from '../types.ts';

/**
 * Renders scatter chart.
 */
export function ScatterChartRenderer({ config, width, height }: ChartRendererProps) {
  const scatterData = [
    {
      name: config.title ?? 'Data',
      color: getSeriesColor(0),
      data: config.data.map((row: Record<string, unknown>) => {
        const xVal = row[config.xAxis];
        const yVal = row[config.yAxis];
        return {
          [config.xAxis]: typeof xVal === 'number' ? xVal : 0,
          [config.yAxis]: typeof yVal === 'number' ? yVal : 0,
        };
      }),
    },
  ];

  return (
    <ScatterChart
      data={scatterData}
      dataKey={{ x: config.xAxis, y: config.yAxis }}
      h={height}
      valueFormatter={{
        x: makeFieldFormatter(config.data, config.xAxis),
        y: makeFieldFormatter(config.data, config.yAxis),
      }}
      w={width}
      withLegend
      withTooltip
      withXAxis
      withYAxis
      xAxisProps={{
        domain: ['auto', 'auto'],
        height: 20,
        fontSize: 12,
        fontWeight: 600,
        tick: {
          fill: 'var(--mantine-color-dark-0)',
        },
      }}
      yAxisProps={{
        domain: ['auto', 'auto'],
        fontSize: 12,
        fontWeight: 600,
        tick: {
          fill: 'var(--mantine-color-dark-0)',
        },
      }}
    />
  );
}
